import { render, staticRenderFns } from "./EducationFullScreen.vue?vue&type=template&id=97457016&scoped=true&"
import script from "./EducationFullScreen.vue?vue&type=script&lang=js&"
export * from "./EducationFullScreen.vue?vue&type=script&lang=js&"
import style0 from "./EducationFullScreen.vue?vue&type=style&index=0&id=97457016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97457016",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97457016')) {
      api.createRecord('97457016', component.options)
    } else {
      api.reload('97457016', component.options)
    }
    module.hot.accept("./EducationFullScreen.vue?vue&type=template&id=97457016&scoped=true&", function () {
      api.rerender('97457016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Education/EducationFullScreen.vue"
export default component.exports